module.exports = __webpack_public_path__ + "static/media/logo-flickr.52aaffb8.svg";